import React, { useState } from 'react';
import { DialogActions, Typography } from '@mui/material';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import CenteredCircularProgress from '../../../../../../../../../../../../../lib/designSystem/CircularProgress';
import CustomAlert from '../../../../../../../../../../../../../lib/designSystem/Alert';
import Summary from '../../../../../create/components/Simulator/components/Summary';
import CreditRequestStatus from '../../../../../../../common/CreditRequestStatus';

const ShoppingCartInTransfer = (props: any) => {
  const { setOpenShoppingCart, openRequest, handleOpenDeleteConfirmModal, handleOpenUpdateStatusModal, canEditRequest } = props;
  const [loading, setLoading] = useState(false);
  const [creditDetails, setCreditDetails] = useState<any>(openRequest);
  const [openWarning, setOpenWarning] = useState(false);
  const [amortizationSchedule, setAmortizationSchedule] = useState<any>(
    openRequest.documents,
  );

  if (loading) return <CenteredCircularProgress type="dialog" />;

  return (
    <div>
      <CreditRequestStatus openRequest={openRequest} audienceType="received" />
      <Summary
        creditDetails={creditDetails}
        amortizationSchedule={amortizationSchedule}
      />
      <DialogActions>
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px 0px',
            gap: '10px',
          }}
        >
          <div
            style={{
              marginTop: 10,
              paddingBottom: 10,
              display: 'flex',
              gap: 10,
            }}
          >
            <Typography
              color="error"
              variant="body1"
              fontWeight="bold"
              style={{ cursor: 'pointer' }}
              onClick={() => handleOpenDeleteConfirmModal()}
            >
              Eliminar
            </Typography>
            {canEditRequest() && (
              <Typography
                color="orange"
                variant="body1"
                fontWeight="bold"
                style={{ cursor: 'pointer' }}
                onClick={() => handleOpenUpdateStatusModal()}
              >
                Editar Estado
              </Typography>
            )}
          </div>
          <div
            style={{
              marginTop: 10,
              paddingBottom: 10,
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 10,
            }}
          >
            <CustomButton
              color="secondary"
              onClick={() => {
                setOpenShoppingCart(false);
              }}
            >
              Salir
            </CustomButton>
          </div>
        </div>
      </DialogActions>
      <CustomAlert
        open={openWarning}
        setOpen={setOpenWarning}
        severity="warning"
        title="Atención"
        text="Si guardas los cambios, se borrarán todas las aprobaciones ya realizadas."
        handleClose={() => setOpenWarning(false)}
      />
    </div>
  );
};

export default ShoppingCartInTransfer;
